import React, { useState } from 'react';

import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { Button, Modal } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import AuthForm from '../../../components/AuthForm/AuthForm';
import AuthInfo from '../../../components/AuthInfo/AuthInfo';
import BankAccountModal from '../../../components/LinkBankAccount/BankAccountModal';

import { Lock } from '../../../assets/icons';
import { Images } from '../../../config/images';
import useGetUserProfile from '../../../Hooks/useGetUserProfile';
import { NOTIFICATION_MESSAGES } from '../../../utils/constant';
import { toastNotify } from '../../../utils/toastNotify';

import './LinkBank.scss';

const LinkBank = () => {
  const navigate = useNavigate();

  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [doneModalOpen, setDoneModalOpen] = useState(false);

  const { userData } = useSelector((state) => state.userData);

  useGetUserProfile();

  const handleConnectBank = () => {
    if (!userData?.isDwollaVerified) {
      toastNotify('error', NOTIFICATION_MESSAGES.WARN_DWOLLA_PENDING);
      navigate('/', {
        replace: true,
      });
      return;
    }

    setBankModalOpen(true);
  };

  return (
    <div className='auth auth--no-info-mobile'>
      <AuthInfo
        title={<>Ready to invest, brick by brick</>}
        description={<>We use Plaid to connect to banks for easy and secure connections.</>}
        note={
          <>
            <Lock marginRight='10px' />
            <span className='fw-400'>All of your information is encrypted and secure.</span>
          </>
        }
      />
      <AuthForm title={<>Link your bank</>} description={<>Transfer funds to your Realbricks account to make your first investment.</>}>
        <>
          <div className='auth-form linkbank'>
            <div className='linkbank__item'>
              <span className='fw-700'>Instant purchase</span>
              <p>Start investing right away with easy and no-fee ACH payments via Plaid.</p>
            </div>
            <div className='linkbank__item'>
              <span className='fw-700'>Add funds</span>
              <p>You can deposit and withdraw funds from your account at any time.</p>
            </div>
            <div className='linkbank__item'>
              <span className='fw-700'>Secure integration</span>
              <p>Realbricks uses Plaid to securily transfer funds from your bank.</p>
            </div>
          </div>
          <div className='auth-form__fixed-submit multi-action'>
            <Link to='/' className='fw-600 back-link'>
              I’ll do this later
            </Link>
            <Button htmlType='submit' type='primary' className='ant-btn-primary--alt' onClick={handleConnectBank}>
              Connect bank
            </Button>
          </div>
          <BankAccountModal
            bankModalOpen={bankModalOpen}
            setBankModalOpen={(value) => setBankModalOpen(value)}
            onSuccess={() => {
              setBankModalOpen(false);
              setDoneModalOpen(true);
            }}
            onClose={() => {
              setBankModalOpen(false);
            }}
          />
          <Modal open={doneModalOpen} footer={false} closable={false} header={false} onCancel={() => setDoneModalOpen(false)} width={524} centered>
            <div className='congrats'>
              <div className='mb-16 congrats__image'>
                <LazyLoadImage src={Images.allSet} alt='' />
              </div>
              <h4 className='mb-0 congrats__title'>You are all set.</h4>
              <h4 className='congrats__title'>Start investing today</h4>
              <p className='mb-48 congrats__detail'>
                You’ve officially joined Realbricks. Browse our property listings and make your first investment.{' '}
              </p>
              <div className='congrats__action'>
                <Button href='/' type='primary' className='ant-btn-primary--alt'>
                  Go to Realbricks Marketplace
                </Button>
                <a href='https://www.realbricks.com/learn' target='_blank' className='fw-600' rel='noreferrer'>
                  Learn about investing
                </a>
              </div>
            </div>
          </Modal>
        </>
      </AuthForm>
    </div>
  );
};

export default LinkBank;
